import {
  Antrag,
  EinreichungComponentType,
  EinreichungStepResultType,
  PopulateUnfinishedAntrag,
} from '@ebeihilfe/einreichung-old';
import { Component, OnInit } from '@angular/core';
import { Deferred, EinreichungComponents } from '@ebeihilfe/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { NoteComponent } from '@ebeihilfe/web-shared/note';
import { TranslateModule } from '@ngx-translate/core';

// eslint-disable-next-line @angular-eslint/prefer-on-push-component-change-detection
@Component({
  selector: 'portal-ebeihilfe-populate-unfinished-antrag',
  templateUrl: './populate-unfinished-antrag.component.html',
  styleUrls: ['./populate-unfinished-antrag.component.scss'],
  imports: [MatCardModule, TranslateModule, MatButtonModule, MatProgressSpinnerModule, NoteComponent],
})
export class PopulateUnfinishedAntragComponent
  extends PopulateUnfinishedAntrag
  implements EinreichungComponentType, OnInit
{
  public component = PopulateUnfinishedAntragComponent;
  public name = EinreichungComponents.PopulateWithUnfinishedAntrag;

  public async ngOnInit(): Promise<void> {
    return super.ngOnInit();
  }

  public async handle(
    antrag: Antrag,
    instance: PopulateUnfinishedAntragComponent,
    work: Deferred<EinreichungStepResultType>,
  ): Promise<EinreichungStepResultType> {
    instance.antrag = antrag;
    instance.work = work;
    return instance.work;
  }
}
